// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.currentSrc || image.src}`);
  const overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
  container.style.touchAction = 'none';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  if (!loadingSpinner) return;
  loadingSpinner.classList.toggle('hidden');
}

function getPointer(event) {
  if (event.touches && event.touches.length) return event.touches[0];
  if (event.changedTouches && event.changedTouches.length) return event.changedTouches[0];
  return event;
}

function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

function moveWithPointer(image, overlay, event, zoomRatio) {
  const pointer = getPointer(event);
  const container = image.getBoundingClientRect();
  const xPosition = clamp(pointer.clientX - container.left, 0, container.width);
  const yPosition = clamp(pointer.clientY - container.top, 0, container.height);
  const xPercent = `${(xPosition / container.width) * 100}%`;
  const yPercent = `${(yPosition / container.height) * 100}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.clientWidth * zoomRatio}px`;
}

function magnify(image, event, zoomRatio) {
  const existingOverlay = image.parentElement.querySelector('.image-magnify-full-size');
  if (existingOverlay) existingOverlay.remove();

  const overlay = createOverlay(image);
  const createdAt = Date.now();
  const move = (moveEvent) => {
    moveEvent.preventDefault();
    moveWithPointer(image, overlay, moveEvent, zoomRatio);
  };

  overlay.addEventListener('click', (clickEvent) => {
    if (Date.now() - createdAt < 500) {
      clickEvent.preventDefault();
      return;
    }

    overlay.remove();
  });
  overlay.addEventListener('mousemove', move);
  overlay.addEventListener('mouseleave', () => overlay.remove());
  overlay.addEventListener('touchstart', move, { passive: false });
  overlay.addEventListener('touchmove', move, { passive: false });

  moveWithPointer(image, overlay, event, zoomRatio);
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    let lastTouchTime = 0;

    image.onclick = (event) => {
      if (Date.now() - lastTouchTime < 700) return;

      event.preventDefault();
      event.stopPropagation();
      magnify(image, event, zoomRatio);
    };

    image.addEventListener(
      'touchstart',
      (event) => {
        lastTouchTime = Date.now();
        event.preventDefault();
        event.stopPropagation();
        magnify(image, event, zoomRatio);
      },
      { passive: false }
    );
  });
}

enableZoomOnHover(2);
